let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("d9I6H")).then(() => parcelRequire('9mwm7'));